module.exports = __webpack_public_path__ + "static/Muli-Regular-8593ce831a9d8562ba38db9bef61e063.ttf";